// Auto generated file, do not manually modify!
// com.hotpads.customermanagement.client.listingspotlight.enums.OptimizationMode

export enum OptimizationMode {
  DOM = 'DOM',
  GEO = 'GEO',
  MARKETPLACE_DYNAMICS = 'MARKETPLACE_DYNAMICS',
  RENT = 'RENT',
}

export const OptimizationMode_values = [
  OptimizationMode.DOM,
  OptimizationMode.GEO,
  OptimizationMode.MARKETPLACE_DYNAMICS,
  OptimizationMode.RENT,
] as const;
